var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('breadcrumbs',{attrs:{"text":_vm.personLabel}}),_vm._v(" "),_c('person-form',{attrs:{"person":_vm.person}}),_vm._v(" "),_c('passport-modal',{on:{"saved":_vm.refresh}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }